// extracted by mini-css-extract-plugin
module.exports = {"clipboard":"styles_clipboard__1isef","clipboard--btn":"styles_clipboard--btn__2ZiyF","clipboard--text":"styles_clipboard--text__3vdRA"};